import React, { FC, useState } from 'react'
import { Button } from 'Pages/landings/common/components/Button'
import { FormComponent } from 'Pages/landings/common/components/Form'
import { Region, Product } from 'Pages/landings/common/types'
import './style.scss'

interface ComponentProps {
	id?: string
	regionId?: number
	sendMessage?: (
		typeMessage: string,
		title: string,
		subTitle: string,
		id: string,
		isClient: boolean
	) => void
	regionsNoDivisions?: Region[]
	products?: Product[]
	subTitle?: string
	title?: string
	regionName?: string
}

const defaultSubTitle =
	'Кредиты на любые цели — недвижимость, авто, контракты, помощь бизнесу.\n' +
	'Подайте заявку онлайн без визита в банк.'

export const FormSectionComponent: FC<ComponentProps> = ({
	id,
	regionId,
	sendMessage,
	regionsNoDivisions = [],
	products,
	subTitle = defaultSubTitle,
	title = 'Подайте заявку на кредит онлайн',
	regionName,
}) => {
	const [isClient, setIsClient] = useState(null)

	const className = {
		blockForm: 'landing-block-form',
		buttonBlack: 'landing-button-black',
		buttonWhite: 'landing-button-white',
		noDisplay: 'landing-no-display',
		titleForm: 'landing-block-form_title',
		subTitleForm: 'landing-block-form_subtitle',
		right: 'landing-block-form_right',
		call: 'landing-call',
		landingBlockFormRow: 'landing-block-form_row',
		landingBlockFormCol: 'landing-block-form_col',
	}

	return (
		<div id="blockForm" className={className.blockForm}>
			<div className={className.landingBlockFormRow}>
				<div className={className.landingBlockFormCol}>
					<div className={className.titleForm}>{title}</div>
					<div className={className.subTitleForm}>{subTitle}</div>
					{isClient === null ? (
						<div className={className.landingBlockFormRow}>
							<div className={className.landingBlockFormCol}>
								<Button onClick={() => setIsClient(true)} type="black">
									Я клиент Сбербанка
								</Button>
							</div>
							<div className={className.landingBlockFormCol}>
								<Button onClick={() => setIsClient(false)} type="white">
									Я не клиент Сбербанка
								</Button>
							</div>
						</div>
					) : (
						<div>
							<FormComponent
								regionName={regionName}
								isClient={isClient}
								token={id}
								onBack={() => setIsClient(null)}
								id={id}
								regionId={regionId}
								regionsNoDivisions={regionsNoDivisions}
								sendMessage={sendMessage}
								products={products}
							/>
						</div>
					)}
				</div>
				<div className={className.landingBlockFormCol}>
					<div className={className.right}>
						<img src="../img/bussines_man.png" alt="" />
					</div>
				</div>
			</div>
		</div>
	)
}
